import MetaInfoUseCase from "../app/metaApi/usecase/metaInfo"

export default {
    data() {
        return {
            // overwrite searchMetaInfo later on the component
            searchMetaInfo: "default",
            metaInfo: "",
        }
    },
    methods: {
        getMetaInfo() {
            MetaInfoUseCase.getMeta(this.searchMetaInfo)
            .then(resp => {
                if (!resp.err && resp.data) {
                    this.metaInfo = resp.data
                }
            })
            .catch((err) => {
                console.log(err)
            })
        }
    },
    created() {
        this.getMetaInfo()
    },
}